import { render, staticRenderFns } from "./ColumnWithDataLabels.vue?vue&type=template&id=06a7faf4&scoped=true&"
import script from "./ColumnWithDataLabels.vue?vue&type=script&lang=js&"
export * from "./ColumnWithDataLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7faf4",
  null
  
)

export default component.exports